export const appConfig = {
    API: `${siteUrl}/api/`, // eslint-disable-line no-undef
};
